// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reset_login__e9lFF{
   width: 100%;
   height: 100vh;
   display: flex;
   place-content: center;
   background-color: #bdbdbd;
}

.Reset_card__S-sPL{
 margin-top: 4%;
 width: 30%;
 height: 450px;
 text-align: center;
 border-radius: 50%;
}

.Reset_text__rsYH3{
   margin-top: 50px;
}

.Reset_inputs__7RK7t{
 padding:8% 8% 8% 3%;
 row-gap: 15px;
 display: grid;
}

.Reset_error__RMypX{
   text-align: right;
   margin-top: -40px;
   margin-bottom: 30px;
   color: red;
   width: 92%;
}

.Reset_btns__M4PJV{
   display:flex;
   flex-wrap: wrap;
   justify-content: space-around;
}

@media screen and (max-width:767px) {
   .Reset_card__S-sPL{
      width : 80%;
      margin: auto;
   }
}`, "",{"version":3,"sources":["webpack://./src/pages/reset/Reset.module.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,aAAa;GACb,aAAa;GACb,qBAAqB;GACrB,yBAAyB;AAC5B;;AAEA;CACC,cAAc;CACd,UAAU;CACV,aAAa;CACb,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,aAAa;AACd;;AAEA;GACG,iBAAiB;GACjB,iBAAiB;GACjB,mBAAmB;GACnB,UAAU;GACV,UAAU;AACb;;AAEA;GACG,YAAY;GACZ,eAAe;GACf,6BAA6B;AAChC;;AAEA;GACG;MACG,WAAW;MACX,YAAY;GACf;AACH","sourcesContent":[".login{\n   width: 100%;\n   height: 100vh;\n   display: flex;\n   place-content: center;\n   background-color: #bdbdbd;\n}\n\n.card{\n margin-top: 4%;\n width: 30%;\n height: 450px;\n text-align: center;\n border-radius: 50%;\n}\n\n.text{\n   margin-top: 50px;\n}\n\n.inputs{\n padding:8% 8% 8% 3%;\n row-gap: 15px;\n display: grid;\n}\n\n.error{\n   text-align: right;\n   margin-top: -40px;\n   margin-bottom: 30px;\n   color: red;\n   width: 92%;\n}\n\n.btns{\n   display:flex;\n   flex-wrap: wrap;\n   justify-content: space-around;\n}\n\n@media screen and (max-width:767px) {\n   .card{\n      width : 80%;\n      margin: auto;\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login": `Reset_login__e9lFF`,
	"card": `Reset_card__S-sPL`,
	"text": `Reset_text__rsYH3`,
	"inputs": `Reset_inputs__7RK7t`,
	"error": `Reset_error__RMypX`,
	"btns": `Reset_btns__M4PJV`
};
export default ___CSS_LOADER_EXPORT___;
